import { FC, PropsWithChildren } from 'react';
import { DataCategory } from '../subheader-category-items/types';
import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import { Conditional } from '../../../common';
import styles from '../subheader-category-items/style.module.scss';
import cx from 'classnames'
import { MAIN_NAV_TRACK } from '../../../../constants/analyticsConstants';

interface CategoryItemsMobileProps {
  categories: DataCategory[];
}

export const SubheaderCategoryItemsMobile: FC<
  PropsWithChildren<CategoryItemsMobileProps>
> = ({ children, categories }) => {
  return (
    <>
      {categories.map(({ key, data }, index) => {
        const displayBuyingOption = index === categories.length - 1;
        return (
          <CatList className={styles['c-top-nav__list']} key={key}>
            {data.map(({ name, seoURL, isActive }) => (
              <CatListItem
                className={cx(styles['c-top-nav__list-item'], {[styles['c-top-nav__list-item--bg']]: isActive })}
                key={name}
                href={seoURL}
                styleModifier={'cat-u-padding-none'}
                data-testid="category-list-item"
                data-track-event={MAIN_NAV_TRACK.EVENT}
                data-track-attr-nltext={name}
                data-track-attr-context={MAIN_NAV_TRACK.TOP_SUBMENU_CONTEXT}
              >
                {name}
              </CatListItem>
            ))}
            <Conditional test={displayBuyingOption}>{children}</Conditional>
          </CatList>
        );
      })}
    </>
  );
};
